<template>
    <router-link
        :class="classList"
        :disabled="disabled"
        :tag="tag"
        :to="$attrs.to"
        v-bind="$attrs"
        v-if="$attrs.to"
        v-on="$listeners"
    >
        <slot></slot>
    </router-link>
    <a
        :class="classList"
        :disabled="disabled"
        :href="$attrs.href"
        v-bind="$attrs"
        v-else-if="$attrs.href"
        v-on="$listeners"
    >
        <slot></slot>
    </a>
    <button :class="classList" :disabled="disabled" v-bind="$attrs" v-else v-on="$listeners">
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: "VButton",
    props: {
        block: Boolean,
        disabled: Boolean,
        upper: Boolean,
        size: String,
        variant: {
            type: String,
            default: "primary"
        },
        type: {
            type: String,
            default: "button"
        },
        circle: Boolean
    },
    computed: {
        classList() {
            let list = [
                { "btn-uppercase": this.upper },
                { "d-block": this.block },
                { "btn-sm": this.size == "sm" },
                { "btn-lg": this.size == "lg" },
                { "btn-xl": this.size == "xl" },
                "btn"
            ];

            if (this.variant && this.variant.length) {
                list.push("btn-" + this.variant);
            }

            if (this.circle) {
                list.push("rounded-circle");
            }

            return list;
        },
        tag() {
            return this.$attrs.href || this.$attrs.to ? "a" : this.type;
        }
    }
};
</script>

<style scoped>
.rounded-circle {
    width: calc(1.5em + 1em);
    height: calc(1.5em + 1em);
    padding: 0.5rem;
    text-align: center;
}
.btn-sm.rounded-circle {
    width: calc(1.5em + 1em);
    height: calc(1.5em + 1em);
    padding: 0.5em;
    text-align: center;
}
.btn-xl {
    padding: 0.5rem 1.25rem;
    font-size: 1.5rem;
    line-height: 1.75;
}
</style>